var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",staticClass:"wrapper"},[_c('BoxMainView',{attrs:{"data":{
    image: 'benefit/img-mv.jpg',
    japanese: 'サポート体制',
    title: 'benefit/txt-mv.svg',
  },"is-animation":_vm.isAnimate,"to-top":_vm.toTop,"is-fix":_vm.isFix}}),_c('div',{staticClass:"wrapper__inner",class:{'is-animation': _vm.isAnimate, 'is-animation-end': _vm.isAnimateEnd}},[_c('section',{staticClass:"training"},[_c('div',{staticClass:"training__inner"},[_c('div',{staticClass:"training__lead"},[_c('TextLead',{attrs:{"text":"当社では、社員一人ひとりが充実した生活を送ることができるよう、各種制度を整え、働きやすい職場環境づくりに取り組んでいます。"}})],1),_c('TitleLarge',{attrs:{"text":"研修制度"}}),_c('div',{staticClass:"system__content"},[_c('TextBody',{attrs:{"text":"新入社員研修、支配人研修、マネージャー研修、サービス改善担当者研修、フォローアップ研修、他ホテル研修、SNSマーケティング研修、社外通信研修等"}})],1),_c('div',{staticClass:"training__content"},[_c('ListColumn',{attrs:{"column":[
            {
              title: '新入社員研修',
              image: 'benefit/img-training-01.jpg',
              body: '社会人としてのマナー、ホテルの基礎知識を習得するとともに、ホテル英会話、企業倫理、ホテルスタッフに必要な笑顔・発声の方法を学びます。',
              caption: '',
            },
            {
              title: 'フォローアップ研修',
              image: 'benefit/img-training-02.jpg',
              body: '同期との再会を通して、現時点での振り返りを行うとともに、後輩育成や先輩社員としての心構えを学び、今後の目標設定をします。',
              caption: '',
            },
            {
              title: 'サービス改善担当者研修',
              image: 'benefit/img-training-03.jpg',
              body: '各ホテル・旅館のサービス改善担当者を選任して、ＪＲ九州ホテルズアンドリゾーツ全体のサービス改善活動を推進しています。',
              caption: '',
            }
          ],"sm-margin":true}})],1)],1)]),_c('section',{staticClass:"welfare"},[_c('div',{staticClass:"welfare__inner"},[_c('TitleLarge',{attrs:{"text":"スキルアップ支援"}}),_c('div',{staticClass:"welfare__content"},[_c('ListVertical',{attrs:{"column":[
            {
              image: 'benefit/img-welfare-02.jpg',
              title: '充実したWEB語学研修',
              body: 'オンラインにて各国の現地専門講師と１対１で25分間会話できるWEB外国語研修。レッスン内容が資格試験対策からフリートークまで幅広く対応しており自分のペースで外国語を習得することができます。受講率が５割に達すれば全額会社負担です。',
            },
            {
              image: 'benefit/img-welfare-03.jpg',
              title: '社外通信研修受講費・資格手当の補助',
              body: '当社が指定する社外通信講座を在籍期間内に受講修了した場合、受講料の全額または3分の2を補助する制度です。約70ある講座の中から興味・関心のある講座を選択できます。<br>また、TOEIC、中国語検定試験、韓国語能力試験等、資格やスコアに応じて毎月会社から手当が支給されます。',
            }
          ]}})],1)],1)]),_c('section',{staticClass:"welfare"},[_c('div',{staticClass:"welfare__inner"},[_c('TitleLarge',{attrs:{"text":"福利厚生"}}),_c('div',{staticClass:"welfare__content"},[_c('ListVertical',{attrs:{"column":[
            {
              image: 'benefit/img-welfare-01.jpg',
              title: '帰省交通費の補助',
              body: '独身者や単身赴任者が家族の元へ帰省する際に実費の7割を会社が補助します。九州外の勤務者は最大年4回（単身赴任者は年6回）上限は1回50,000円まで、九州島内勤務者は最大年4回(単身赴任者は年12回）上限1回30,000円を支給します。',
            } ]}})],1)],1)]),_c('section',{staticClass:"other"},[_c('div',{staticClass:"other__inner"},[_c('div',{staticClass:"other__content"},[_c('TableNoBorder',{attrs:{"table":[
            {
              th: '住宅援助金',
              td: '借家の住居に入居している社員等に対して月額30,000円を支給します。',
            },
            {
              th: '人間ドック受診費用の助成',
              td: '人間ドックを受診した社員は、その領収書を提出した場合、1年に1回限り30,000円の補助金を支給します。',
            },
            {
              th: 'インフルエンザ予防接種費用の助成',
              td: '対象期間にインフルエンザの予防接種を受けた場合、費用の全額を会社が負担します。',
            },
            {
              th: 'ベネフィット・ワン',
              td: '入会すると映画館やレジャー施設をお得な会員料金で利用できます。',
            } ]}})],1)])]),_c('section',{staticClass:"other"},[_c('div',{staticClass:"other__inner"},[_c('TitleLarge',{attrs:{"text":"ワークライフバランス"}}),_c('div',{staticClass:"other__content"},[_c('TableNoBorder',{attrs:{"table":[
            {
              th: '各種休職制度あり',
              td: '育児休職、介護休職、病気休職',
            },
            {
              th: '復職後の支援制度あり',
              td: '短時間勤務、深夜勤務の免除など',
            } ]}})],1)],1)]),_c('BoxEntry')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }